import { Component } from "react";
import { useLocation } from "react-router-dom";

// Branded fallback for render errors and stale code chunks after a release (no blank page, no provider branding).
class Boundary extends Component {
  constructor(props) { super(props); this.state = { failed: false, chunk: false }; }
  static getDerivedStateFromError(err) {
    return { failed: true, chunk: /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module/i.test(`${err?.name} ${err?.message}`) };
  }
  componentDidCatch(err) { console.error("[app] render error", err?.message); }
  componentDidUpdate(prev) { if (this.state.failed && prev.pathname !== this.props.pathname) this.setState({ failed: false, chunk: false }); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[70vh] bg-white pt-36 pb-24 px-6 text-center" data-testid="app-error-page">
        <p className="text-xs tracking-widest uppercase" style={{ color: "#8f7d45" }}>American Farmstand</p>
        <h1 className="mt-3 text-3xl" style={{ color: "#0f1d2f", fontFamily: "'GFS Didot', 'Didot', Georgia, serif" }}>
          {this.state.chunk ? "A fresh version is ready" : "Something went wrong"}
        </h1>
        <p className="mt-3 text-sm" style={{ color: "#0f1d2f", opacity: 0.65 }}>
          {this.state.chunk ? "We updated the site while you were here. Reload to continue." : "This page couldn't be shown. Your saved information is safe."}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <button onClick={() => window.location.reload()} className="px-6 py-3 text-xs tracking-widest uppercase" style={{ backgroundColor: "#0f1d2f", color: "#fff" }} data-testid="app-error-reload">Reload page</button>
          <a href="/" className="px-6 py-3 text-xs tracking-widest uppercase border" style={{ borderColor: "#0f1d2f", color: "#0f1d2f" }} data-testid="app-error-home">Back to the farmstand</a>
        </div>
      </div>
    );
  }
}

// Clears the error page when the member navigates (header/footer links sit outside the boundary).
export function AppErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <Boundary pathname={pathname}>{children}</Boundary>;
}
